export default "__VITE_ASSET__BCe0LGez__"